import { grayscale, invert, getContrast } from "polished";
/**
 * Transform text color to grayscale and calculate the color with the highest contrast to the background color
 * @param textColor Colot to be compared
 * @param backgroundColor Background color with which the color should be compared
 * @returns Color with the highest contrast to the background color
 */
export function bestReadableColor(textColor, backgroundColor) {
    // Convert color to grayscale
    const grayTextColor = grayscale(textColor);
    // Get inverted grayscale color
    const invertedGrayTextColor = invert(grayTextColor);
    // Get contrast between background and grayscale color
    const withColor = getContrast(backgroundColor, grayTextColor);
    // Get contrast between background and inverted grayscale color
    const withInvertedColor = getContrast(backgroundColor, invertedGrayTextColor);
    // Return the color with the highest contrast
    return withColor > withInvertedColor ? grayTextColor : invertedGrayTextColor;
}
//# sourceMappingURL=utils.js.map